/**
 * Created by Ivan on 27.09.2025
 */

const RaveReviewsIcon = function (row) {
    const config = bundles.rave_reviews_icon.jsons.ravereviewsicon_prefab_json;
    return Prefab.instantiate(config, { row });
};